import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getPRS(params, signal) {
  return request({
    url: '/prsTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getPRSTotal(params, signal) {
  return request({
    url: '/prsTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/prsTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deletePRS(uuid) {
  return request({
    url: `/prsTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const prsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeletePRSTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/prsTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeletePRSTCHsMutation: useBulkDeletePRSTCHs,
} = prsApi;

export default prsApi;
